import { apiClient } from 'services/api-client';
import { AgentTokenResult, ConnectionTransport, PairingResult, POSConnection, POSProvider, POSProviderOption, SyncRun } from 'dtos/integrations/connection.dto';

export const connectionService = {
  listProviders: async () => (await apiClient.get<POSProviderOption[]>('/connections/providers')).data,
  list: async (organizationId: string) => (await apiClient.get<POSConnection[]>(`/orgs/${organizationId}/connections`)).data,
  create: async (organizationId: string, input: { store_id: string; provider: POSProvider; transport: ConnectionTransport }) =>
    (await apiClient.post<PairingResult>(`/orgs/${organizationId}/connections`, input)).data,
  provisionToken: async (organizationId: string, connectionId: string) =>
    (await apiClient.post<AgentTokenResult>(`/orgs/${organizationId}/connections/${connectionId}/agent-token`)).data,
  test: async (organizationId: string, connectionId: string) =>
    (await apiClient.post<{ connection: POSConnection; message: string }>(`/orgs/${organizationId}/connections/${connectionId}/test`)).data,
  delete: async (organizationId: string, connectionId: string) =>
    apiClient.delete<void>(`/orgs/${organizationId}/connections/${connectionId}`),
  sync: async (organizationId: string, connectionId: string) =>
    (await apiClient.post<SyncRun>(`/orgs/${organizationId}/connections/${connectionId}/sync`)).data,
};
